// @flow
import { connect } from 'react-redux';
import type { State, Message as MessageType } from '../../../types';
import { makeUserEntitySelector } from '../../../selectors/usersSelectors';
import { makeCarEntityAutoSelector, callsignSelector } from '../../../selectors/carSelectors';
import Message from '../Message';
import type { Props } from '../Message';

type OwnProps = $ReadOnly<{
    message: MessageType,
    showRecipient?: boolean
}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    const icao = props.message.icao;
    const userId = props.message.userId;

    let callsign;
    let user;
    if(props.showRecipient && icao) {
        if(icao) {
            const targetBuffer = makeCarEntityAutoSelector(icao)(state);
            callsign = callsignSelector(icao, targetBuffer)(state);
        }
        if(userId) {
            const userEntity = makeUserEntitySelector(userId)(state);
            user = userEntity && userEntity.name;
        }
    }

    return {
        callsign,
        user
    };
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(Message);